import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import {
  DELIVERY_INFO_MODS,
  DELIVERY_SELECT_MOCK,
  WAREHOUSE_INFO_MODS,
  WAREHOUSE_OPERATIONS,
  WAREHOUSE_TYPES,
} from '../../../../../config';
import Button from '../../../../common/Button';
import InputWrapper from '../../../../common/InputWrapper';
import Checkbox from '../../../../common/Checkbox';
import SelectComponent from '../../../../common/Select';
import {
  fetchGetAdminWarehouse,
  fetchPostCheckConnection,
  fetchPostWarehouseCorrection,
} from '../../../../../actions/admin';
import { toast } from 'react-toastify';
import { parseError } from '../../../../../helpers';

const Wrapper = styled('div')`
  .text-center {
    width: 100%;
    text-align: center;
  }

  .table .thead-light th:nth-child(n + 2) {
    text-align: center !important;
  }

  .flex-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
    margin-top: 10px;
  }

  .error-text {
    margin-top: 8px;
    color: red;
    margin-bottom: -35px;
  }
`;

const Info = (props) => {
  const { handleSwitchMode, mode, item, fulfillmentType, isNew } = props;
  const dispatch = useDispatch();
  const [subTypes, setSubTypes] = useState([]);
  const [isUnsaved, setIsUnsaved] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: item.title || null,
      isDefault: item.isDefault || false,
      operatorType: item.operatorType || null,
      fulfillmentType: item.fulfillmentType || null,
      fulfillmentSubType: item.fulfillmentSubType || null,
      operationType: item.operationType || null,
      address: item.address || null,
      code: item.code,
      apiLogin: item.apiLogin,
      apiPassword: item.apiPassword,
    },
    enableReinitialize: true,
  });

  const { values, errors, submitCount, handleChange, setFieldValue } = formik;

  const createNewFulfillmentSubTypeArray = (arrayOfTypes) => {
    if (arrayOfTypes === null || arrayOfTypes === undefined) {
      return [];
    }

    const newSubTypes = arrayOfTypes.map((item) => {
      return {
        value: item.fulfillmentSubType,
        label: item.fulfillmentSubTypeTitle,
        address: item.address,
      };
    });

    setSubTypes(newSubTypes);
  };

  useEffect(() => {
    createNewFulfillmentSubTypeArray(fulfillmentType[0].fulfillmentSubTypes);
  }, []);

  const findFulfillmentSubType =
    subTypes.find((item) => item.value === values.fulfillmentSubType)?.label || null;

  const findCurrentAddress =
    subTypes.find((item) => item.value === values.fulfillmentSubType)?.address.fullAddress || null;

  const handleSubFulfillmentType = (value) => {
    setFieldValue('fulfillmentSubType', value.value);
  };

  const handleSubmit = () => {
    dispatch(fetchPostWarehouseCorrection(values, 'EDIT'))
      .then(() => {
        toast.info('Информация о складе сохранена');
        dispatch(fetchGetAdminWarehouse());
        handleSwitchMode(WAREHOUSE_INFO_MODS.LIST);
        setIsUnsaved(false);
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  const handleWarehouseType = (value) => {
    if (value === 'FULFILLMENT') {
      setFieldValue('operatorType', value);
      setFieldValue('fulfillmentType', 'TEMPOLINE');
      setFieldValue('operationType', 'STORAGE');
      setFieldValue('fulfillmentSubType', null);
      setFieldValue('apiLogin', null);
      setFieldValue('apiPassword', null);
    }
    if (value === 'MANUAL') {
      setFieldValue('operatorType', value);
      setFieldValue('fulfillmentType', null);
    }
  };

  const handleCheckConnection = () => {
    dispatch(fetchPostCheckConnection(item.code));
  };

  const getOperationFieldLabel = (array, value) => {
    return array.find((item) => item.value === value).label;
  };

  const handleFieldValue = (type, value) => {
    setIsUnsaved(true);
    setFieldValue(type, value);
  };

  return (
    <Wrapper>
      <form>
        <div className="row" style={{ marginTop: '10px' }}>
          {mode === WAREHOUSE_INFO_MODS.INFO && (
            <Button
              type="button"
              text="&#8592; Назад к списку складов"
              onClick={() => handleSwitchMode(WAREHOUSE_INFO_MODS.LIST)}
            />
          )}
          {mode === WAREHOUSE_INFO_MODS.EDIT && (
            <>
              <div className="col-3">
                <Button
                  type="button"
                  text="&#8592; Отменить изменения и вернуться к списку складов"
                  onClick={() => handleSwitchMode(WAREHOUSE_INFO_MODS.LIST)}
                />
              </div>
              <div className="mr-auto col-3">
                <Button type="button" text="Сохранить изменения" onClick={() => handleSubmit()} />
              </div>

              {values.operatorType === 'FULFILLMENT' && (
                <div className="col-3 text-right">
                  <Button
                    type="button"
                    text="Тест соединения"
                    onClick={handleCheckConnection}
                    style={{ backgroundColor: '#8bb743', border: '1px solid #8bb743' }}
                    disabled={isUnsaved}
                  />
                  {isUnsaved && (
                    <p className="error-text">Сохраните изменения перед тестом соединения</p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <div className="form-group" style={{ marginTop: '18px' }}>
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <InputWrapper /*Название склада*/
                label="Название склада"
                id="title"
                value={values.title}
                onChange={(e) => handleFieldValue('title', e.target.value)}
                isDisabled={mode === WAREHOUSE_INFO_MODS.INFO}
              />
            </div>
            <div className="col-6">
              <SelectComponent /*Тип склада*/
                label="Тип склада"
                id="type"
                options={WAREHOUSE_TYPES}
                value={
                  {
                    value: values.operatorType,
                    label:
                      values.operatorType &&
                      getOperationFieldLabel(WAREHOUSE_TYPES, values.operatorType),
                  } || {
                    value: 'FULFILLMENT',
                    label: 'Фулфилмент',
                  }
                }
                onChange={(value) => handleWarehouseType(value.value)}
                isDisabled={!isNew} // Если склад новый, можно редактировать
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <InputWrapper /*Оператор ФФ*/
                label="Оператор ФФ"
                id="type"
                value={values.fulfillmentType === 'TEMPOLINE' ? 'Темполайн' : null}
                onChange={(e) => handleFieldValue('fulfillmentType', e.target.value)}
                isDisabled={true}
              />
            </div>
            <div className="col-6">
              <SelectComponent /*Тип операций склада*/
                label="Тип операций склада"
                id="type"
                options={WAREHOUSE_OPERATIONS}
                value={
                  {
                    value: values.operationType,
                    label:
                      values.operationType &&
                      getOperationFieldLabel(WAREHOUSE_OPERATIONS, values.operationType),
                  } || {
                    value: 'STORAGE',
                    label: 'Хранение',
                  }
                }
                onChange={(value) => handleFieldValue('operationType', value.value)}
                isDisabled={values.operatorType === 'FULFILLMENT' && isNew !== true}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <SelectComponent
                label="География склада"
                options={subTypes}
                value={{
                  value: values.fulfillmentSubType,
                  label: findFulfillmentSubType || values.fulfillmentSubType,
                }}
                onChange={(value) => handleSubFulfillmentType(value)}
                isClearable={false}
                isDisabled={
                  ((values.operatorType === 'MANUAL' || values.operatorType === null) &&
                    isNew === true) ||
                  (isNew !== true && values.operatorType === 'MANUAL')
                }
              />
            </div>
            <div className="col-6">
              <InputWrapper /*Адрес склада*/
                label="Адрес склада"
                id="operationType"
                value={findCurrentAddress || null}
                onChange={(e) => handleFieldValue('address', e.target.value)}
                isDisabled={true}
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-6">
              <InputWrapper /*Логин*/
                label="Логин"
                id="apiLogin"
                value={values.apiLogin || null}
                onChange={(e) => handleFieldValue('apiLogin', e.target.value)}
                isDisabled={
                  ((values.operatorType === 'MANUAL' || values.operatorType === null) &&
                    isNew === true) ||
                  (isNew !== true && values.operatorType === 'MANUAL')
                }
              />
            </div>
            <div className="col-6">
              <InputWrapper /*Пароль*/
                label="Токен API WMS"
                id="apiPassword"
                value={values.apiPassword || null}
                onChange={(e) => handleFieldValue('apiPassword', e.target.value)}
                isDisabled={
                  ((values.operatorType === 'MANUAL' || values.operatorType === null) &&
                    isNew === true) ||
                  (isNew !== true && values.operatorType === 'MANUAL')
                }
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-3">
              <Checkbox
                id="isDefault"
                label="По умолчанию"
                checked={values.isDefault}
                onChange={(e) => handleFieldValue('isDefault', e.target.checked)}
                disabled={mode === WAREHOUSE_INFO_MODS.INFO}
              />
            </div>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};

export default Info;
